import { useState } from "react";

import { buildErrorMessage } from "@/helpers/error-helpers";
import useToast from "@/contexts/toast-context";
import { ILinkedProductCategoryBatch } from "@/interfaces/linked-product-category.interface";
import linkedProductCategoryService from "@/services/linked-product-category.service";
import { RequestsProps } from "@/types/requests.types";

export type SaveLinkedCategoriesProps = RequestsProps & {
  data: ILinkedProductCategoryBatch;
};

export type UseSaveLinkedCategoriesReturn = {
  saveCategories: (props: SaveLinkedCategoriesProps) => Promise<void>;
  isLoading: boolean;
};

const useSaveLinkedCategories = (): UseSaveLinkedCategoriesReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();

  const saveCategories = async ({
    data,
    successMessage,
    errorMessage,
    onSuccess,
    onError,
  }: SaveLinkedCategoriesProps) => {
    setIsLoading(true);
    try {
      await linkedProductCategoryService.saveBatch(data);

      if (successMessage) {
        showToast({
          text: successMessage,
          type: "success",
          duration: 3000,
        });
      }

      if (onSuccess) onSuccess();
    } catch (error) {
      const message = buildErrorMessage(error, errorMessage);
      showToast({
        text: message,
        type: "error",
        duration: 5000,
      });

      if (onError) onError();
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { saveCategories, isLoading };
};

export default useSaveLinkedCategories;
